import React, { forwardRef } from "react";

const Input = forwardRef(
  (
    {
      className = "",
      type = "text",
      error,
      label,
      disableWheel = true,
      allowDecimal = true,
      ...props
    },
    ref,
  ) => {
    // -------------------------
    // Handlers
    // -------------------------

    const handleWheel = (e) => {
      if (disableWheel && type === "number") {
        e.target.blur(); // prevents scroll from changing value
      }
    };

    const handleKeyDown = (e) => {
      if (type === "number") {
        // Block unwanted characters
        if (["e", "E", "+", "-"].includes(e.key)) {
          e.preventDefault();
        }

        // Optional: block decimal if not allowed
        if (!allowDecimal && e.key === ".") {
          e.preventDefault();
        }
      }

      if (props.onKeyDown) props.onKeyDown(e);
    };

    // -------------------------
    // Checkbox
    // -------------------------
    if (type === "checkbox") {
      return (
        <input
          type="checkbox"
          className="h-4 w-4 mx-1 rounded border border-input bg-background text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          ref={ref}
          {...props}
        />
      );
    }

    // -------------------------
    // Radio
    // -------------------------
    if (type === "radio") {
      return (
        <input
          type="radio"
          className={`h-4 w-4 mx-1 rounded-full border border-input bg-background text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
          ref={ref}
          {...props}
        />
      );
    }

    // -------------------------
    // Base Input Styles
    // -------------------------
    const baseClass = `flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm ${
      error
        ? "border-destructive focus-visible:ring-destructive"
        : "border-input focus-visible:ring-ring"
    }`;

    // -------------------------
    // Default Input
    // -------------------------
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-foreground mb-1.5">
            {label}
          </label>
        )}

        <input
          type={type}
          ref={ref}
          className={`${baseClass} ${className}`}
          onWheel={handleWheel}
          onKeyDown={handleKeyDown}
          {...props}
        />

        {error && <p className="text-sm text-destructive mt-1">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";

export default Input;
